import inventoryModule from "../inventoryModule.js";

const inventoryComponent = {
    templateUrl: "inventory",
    bindings: {
        "userId": "<",
        "username": "@",
        "displayName":"@"
    },
    controller: "inventoryContentController"
};

inventoryModule.component("inventory", inventoryComponent);
export default inventoryComponent;